import React from 'react';
import styles from './UserInfoAvatar.module.scss';
import { countries } from '../../../../constants/countries';
import { AppAvatar } from '../../../../components/Avatar';
import { Link } from 'react-router-dom';
import { removeDuplicatesFromArray } from '../../../../utils/dataUtils';

const INVITED_BY = 'Invited by';
const KYC = 'KYC';

const getUserLanguagesFlags = (languages) => {
  const flags = [];

  languages.forEach((item) => {
    countries.forEach((country) => {
      if (String(item.language.code).toUpperCase().includes(String(country.lg).toUpperCase())) {
        flags.push(country.flag);
      }
    });
  });

  const filteredFlags = removeDuplicatesFromArray(flags);
  return (
    <>
      {filteredFlags.map((item) => (
        <img
          src={item}
          alt=""
          style={{ width: 26, height: 16, marginTop: 5, objectFit: 'cover', borderRadius: 5 }}
        />
      ))}
    </>
  );
};

const UserInfoAvatar = ({ userProps }) => (
  <>
    {userProps && (
      <div className={styles.middleContent}>
        <div className={styles.nameBLock}>
          <div className={styles.name}>{`${userProps?.first_name} ${userProps?.last_name}`}</div>
          {userProps?.kyc && userProps?.kyc === 'success' && (
            <div className={styles.successKyc}>{KYC}</div>
          )}
          {userProps?.kyc && userProps?.kyc === 'pending' && (
            <div className={styles.pendingKyc}>{KYC}</div>
          )}
        </div>
        {userProps?.experiences && (
          <div className={styles.position}>
            {userProps?.experiences ? userProps?.experiences[0]?.title : 'JobTitle'}
          </div>
        )}
        <div className={styles.avatar}>
          <AppAvatar
            nav={0}
            role={userProps.role_name}
            size="mdl"
            userName={`${userProps.first_name} ${userProps.last_name}`}
            src={userProps.avatar}
          />
        </div>
        <div className={styles.countryFlag}>
          {getUserLanguagesFlags(userProps?.languages || [])}
        </div>
        {userProps?.invited_by_name && (
          <div className={styles.invitedBy}>
            <span>{`${INVITED_BY} `}</span>
            <Link
              to={`/dashboard/profile/${userProps?.invited_by_id}`}
              className={styles.inviterName}
            >
              {userProps?.invited_by_name}
            </Link>
          </div>
        )}
      </div>
    )}
  </>
);
export default UserInfoAvatar;
